<template>
  <div class="step-qna neighborhood-questions-section">
    <div>
      <b-container>
        <b-row class="d-flex justify-content-center">
          <h4>Is there an HOA?</h4>
        </b-row>
        <b-row class="d-flex justify-content-center h-buttons">          
          <b-button 
            class="button yes-no" 
            pill 
            variant="outline-secondary" 
            :pressed="hoa === true"
            @click="onSelectedValue('hoa', 'hoa', true)">Yes
          </b-button>
          <b-button 
            class="button yes-no"
            pill 
            variant="outline-secondary" 
            :pressed="hoa === false"
            @click="onSelectedValue('hoa', 'hoa', false)"
          >
            No
          </b-button>
        </b-row>
      </b-container>
    </div>
    <div v-if="hoa === true">
      <section>
        <div class="d-flex justify-content-center">
          <h4>What are the HOA fees?</h4>
        </div>
        <b-container class="d-flex justify-content-center">
          <b-row>
            <b-col>
              <b-input-group>
                <b-input-group-prepend is-text>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-currency-dollar" viewBox="0 0 16 16">
                    <path d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z"/>
                  </svg>
                </b-input-group-prepend>
                <b-form-input class="number-input" @blur="onBlur" v-model="hoaAmount" type="number" placeholder="HOA Fees"></b-form-input>
              </b-input-group>
            </b-col>            
          </b-row>
        </b-container>
      </section>
      <div v-if="hoaAmount && hoaAmount !== ''">
        <section>
          <div class="d-flex justify-content-center">
            <h4>How often are they due?</h4>
          </div>
          <b-container class="h-buttons">
          <b-row>
            <b-col>
              <b-button class="button" 
                pill variant="outline-secondary"
                :pressed="hoaInterval === 'monthly'"
                @click="setHoaFees('monthly')"
              >
                Monthly
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button class="button" 
                pill variant="outline-secondary"
                :pressed="hoaInterval === 'quarterly'"
                @click="setHoaFees('quarterly')"
              >
                Quarterly
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button class="button" 
                pill variant="outline-secondary"
                :pressed="hoaInterval === 'annually'"
                @click="setHoaFees('annually')"
              >
                Annually
              </b-button>
            </b-col>
          </b-row>
        </b-container>
        </section>
      </div>
      <section>
        <div class="d-flex justify-content-center">
          <h4>Does your HOA allow rentals in the neighborhood?</h4>
        </div>
        <b-container class="h-buttons">
          <b-row>
            <b-col>
              <b-button class="button yes-no" 
                pill variant="outline-secondary"
                :pressed="hoaRentals === 'Yes'"
                @click="onSelectedValue('hoaRentals', 'hoaAllowsRentals', 'Yes')"
              >
                Yes
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button class="button yes-no" 
                pill variant="outline-secondary"
                :pressed="hoaRentals === 'No'"
                @click="onSelectedValue('hoaRentals', 'hoaAllowsRentals', 'No')"
              >
                No
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button class="button yes-no" 
                pill variant="outline-secondary"
                :pressed="hoaRentals === 'Unsure'"
                @click="onSelectedValue('hoaRentals', 'hoaAllowsRentals', 'Unsure')"
              >
                Unsure
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </section>
      </div>
  </div>
</template>
<script>
import {saveField} from "@/services/apiService";

export default {
  name: "PropertyQuestions",
  data (){
    return {
      hoa: undefined,
      hoaAmount: undefined,
      hoaInterval: undefined,
      hoaIntervalStr: 'HOA Interval',
      hoaRentals:undefined
    }
  },
  methods: {
    setHoaFees: function (interval) {
      const field = 'hoaInterval';
      this.setLocalValue(field, interval);
      switch (interval) {
        case 'monthly':
          this.$emit('on-value-entry', { field: field, saveAs: 'monthlyHoaFees', value: this.hoaAmount });
          saveField('monthlyHoaFees', this.hoaAmount)
          break;
        case 'quarterly':
          this.$emit('on-value-entry', { field: field, saveAs: 'quarterlyHoaFees', value: this.hoaAmount });
          saveField('quarterlyHoaFees', this.hoaAmount)
          break;
        case 'annually':
          this.$emit('on-value-entry', { field: field, saveAs: 'annualHoaFees', value: this.hoaAmount });
          saveField('annualHoaFees', this.hoaAmount)
          break;
      }
    },
    onSelectedValue: function (field, saveAs, value) {
      this.setLocalValue(field, value)
      this.$emit('on-value-entry', { field: field, saveAs: saveAs, value: value });
      saveField(saveAs, value);
    },
    setLocalValue: function (field, value) {
      switch (field) {
        case 'hoa':
          this.hoa = value;
          break;
        case 'hoaAmount':
          this.hoaAmount = value;
          break;
        case 'hoaInterval':
          this.hoaInterval = value;
          break;
        case 'hoaRentals':
          this.hoaRentals = value;
          break;
        default:
          return false;
      }
    },
    onBlur(event) {
      this.setLocalValue('hoaAmount', event.target.value)
    }
  }
}
</script>